import { mapGetters } from 'vuex'

export var parcelMixin = {
  computed: {
    ...mapGetters({
      flagsList: 'flagsModule/getFlags',
    }),
  },
  methods: {
    getCondicaoPgtoDefault() {
      const flag = this.flagsList.filter(
        (flag) => flag.DESCRICAO === 'CondicaoParcelamentoDefault'
      )[0]
      if (flag && flag.DESCRICAO) return flag.PARAMETRO
    },
    getCTCondicaoPgto(cts) {
      let ctSelected = undefined
      if (cts) {
        let list = typeof cts === 'string' ? cts.split(',') : cts

        if (list[list.length - 1] == '') list.pop()

        list.some((element) => {
          // retorna o primeiro elemento do ct, conforme PDV Desktop
          if (element !== 'Nenhum' && list.length > 0) {
            ctSelected = element
            return true
          } else {
            ctSelected = element
            return true
          }
        })
      }
      return ctSelected
    },
  },
}
